import cn from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import styles from './PaginationWrapper.module.scss';

export function PaginationWrapper({ children, reportTable = false }) {
  return <div className={cn(styles.paginationWrapper, reportTable ? styles.reportTable : '')}>{children}</div>;
}

PaginationWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  reportTable: PropTypes.bool,
};
